










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseActivity from '@/components/administration/activity/edit/EditBaseActivity.vue'
import EditBasePage from '@/components/shared/EditBasePage.vue'
import { getDefaultAloActivity } from '@/models/alo/AloActivity'
import { AloActivity } from '@/models/alo/AloActivity'

@Component({
  name: 'EditPage',     
  components:{EditBaseActivity,EditBasePage}
})
export default class EditPage extends Vue {
      
  private activity:AloActivity = getDefaultAloActivity()
  private showApercu = false

  get codeYoutube(){
    return  this.activity?.configActivity?.youtube
  }
  set codeYoutube(newValue){
    this.activity.configActivity.youtube = newValue.replace('https://youtu.be/','')
  }


  get infosPlusString(){
    return  this.activity?.configActivity?.infosPlus?.join('\n')
  }
  set infosPlusString(newValue){
    this.activity.configActivity.infosPlus = newValue.split('\n').filter(a => a.length > 0)
  }

  get objectifsPlusString(){
    return  this.activity?.configActivity?.objectifsPlus?.join('\n')
  }
  set objectifsPlusString(newValue){
    this.activity.configActivity.objectifsPlus = newValue.split('\n').filter(a => a.length > 0)
  }

  edit(item:AloActivity) {          
    this.activity = (this.$refs.baseEdit as EditBaseActivity).edit(item)    
  }        
}
